import React, { useEffect, useRef } from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    Stack,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import FormularioNichos from "./components/FormularioNichos";
import { gerarLinkWhatsApp } from "../../../utils/WhatsappLink";


export default function Infoprodutor() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const secaoRef = useRef(null);
        const irParaSecao = () => {
            secaoRef.current.scrollIntoView({
                behavior: "smooth",
            });
        };
    return (
        <>
            <Header />
            <Box sx={{ background: "#fff", marginTop: 2 }}>
                {/* HERO */}
                <Box
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                        py: { xs: 10, md: 18 },
                        background: `
                            radial-gradient(circle at top left, rgba(156,1,185,0.12), transparent 40%),
                            radial-gradient(circle at bottom right, rgba(30,255,134,0.10), transparent 40%),
                            #FFFFFF
                        `,
                    }}
                >
                    {/* Glow Roxo */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 450,
                            height: 450,
                            background: "#9C01B9",
                            opacity: 0.08,
                            borderRadius: "50%",
                            filter: "blur(120px)",
                            top: -150,
                            left: -150,
                        }}
                    />

                    {/* Glow Verde */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 400,
                            height: 400,
                            background: "#1EFF86",
                            opacity: 0.08,
                            borderRadius: "50%",
                            filter: "blur(120px)",
                            bottom: -150,
                            right: -100,
                        }}
                    />

                    <Container maxWidth="lg">
                        <Stack
                            spacing={4}
                            alignItems="center"
                            textAlign="center"
                            sx={{
                                position: "relative",
                                zIndex: 2,
                            }}
                        >
                            {/* Badge */}
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                    backdropFilter: "blur(10px)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 14,
                                        fontWeight: 700,
                                        color: "#9C01B9",
                                    }}
                                >
                                    ESPECIALISTAS EM INFOPRODUTORES
                                </Typography>
                            </Box>

                            {/* Título */}
                            <Typography
                                component="h1"
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1,
                                    letterSpacing: "-0.04em",
                                    maxWidth: 1000,
                                    fontSize: {
                                        xs: "2.8rem",
                                        sm: "4rem",
                                        md: "5.5rem",
                                    },
                                }}
                            >
                                Contabilidade para{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background:
                                            "linear-gradient(90deg,#9C01B9 0%, #1EFF86 100%)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Infoprodutores
                                </Box>
                            </Typography>

                            {/* Subtítulo */}
                            <Typography
                                sx={{
                                    maxWidth: 800,
                                    color: "#5A5A5A",
                                    fontWeight: 400,
                                    lineHeight: 1.7,
                                    fontSize: {
                                        xs: "1.05rem",
                                        md: "1.35rem",
                                    },
                                }}
                            >
                                Freelancer que opera no CPF paga até 27,5% de IR. Com CNPJ no Simples Nacional, você começa com 6%. A ContBlack faz essa transição em menos de 10 dias.
                            </Typography>

                            {/* CTA */}
                            <Button
                                size="large"
                                sx={{
                                    px: 5,
                                    py: 2,
                                    borderRadius: "16px",
                                    fontWeight: 800,
                                    fontSize: "1rem",
                                    textTransform: "none",
                                    background:
                                        "linear-gradient(135deg,#9C01B9 0%, #B800D8 100%)",
                                    color: "#FFF",
                                    boxShadow:
                                        "0 20px 40px rgba(156,1,185,0.30)",
                                    transition: ".3s",
                                    "&:hover": {
                                        transform: "translateY(-3px)",
                                        boxShadow:
                                            "0 30px 60px rgba(156,1,185,0.45)",
                                    },
                                }}
                                onClick={irParaSecao}
                            >
                                Falar com Especialista
                            </Button>

                            {/* Trust Indicators */}
                            <Stack
                                direction={{ xs: "column", sm: "row" }}
                                spacing={3}
                                sx={{
                                    mt: 2,
                                }}
                            >
                                {[
                                    "Atendimento em todo Brasil",
                                    "100% Digital",
                                    "Especialistas no Nicho",
                                ].map((item) => (
                                    <Stack
                                        key={item}
                                        direction="row"
                                        spacing={1}
                                        alignItems="center"
                                    >
                                        <Box
                                            sx={{
                                                width: 10,
                                                height: 10,
                                                borderRadius: "50%",
                                                background: "#1EFF86",
                                                boxShadow:
                                                    "0 0 12px #1EFF86",
                                            }}
                                        />

                                        <Typography
                                            sx={{
                                                color: "#444",
                                                fontWeight: 600,
                                            }}
                                        >
                                            {item}
                                        </Typography>
                                    </Stack>
                                ))}
                            </Stack>
                        </Stack>
                    </Container>
                </Box>

                {/* DORES */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        position: "relative",
                        overflow: "hidden",
                        background: "#FAFAFA",
                    }}
                >
                    {/* Glow */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 500,
                            height: 500,
                            background: "#9C01B9",
                            opacity: 0.05,
                            borderRadius: "50%",
                            filter: "blur(140px)",
                            top: -200,
                            right: -150,
                        }}
                    />

                    <Container maxWidth="lg">
                        {/* Cabeçalho */}
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 8 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 13,
                                        fontWeight: 700,
                                        color: "#9C01B9",
                                        letterSpacing: 1,
                                    }}
                                >
                                    PRINCIPAIS DESAFIOS
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    maxWidth: 900,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Os problemas que mais afetam{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background:
                                            "linear-gradient(90deg,#9C01B9,#C300E5)",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    infoprodutores
                                </Box>
                            </Typography>

                            <Typography
                                sx={{
                                    maxWidth: 750,
                                    color: "#666",
                                    fontSize: {
                                        xs: "1rem",
                                        md: "1.15rem",
                                    },
                                    lineHeight: 1.8,
                                }}
                            >
                                Um infoprodutor no Anexo V do Simples pagando 15,5% sobre um lançamento de R$50.000 deixa R$7.750 para o governo. Com planejamento de Fator R correto no Anexo III a 6%, esse mesmo lançamento gera apenas R$3.000 de imposto. São R$4.750 a mais no seu bolso, em um único lançamento.
                            </Typography>
                        </Stack>

                        {/* Cards */}
                        <Grid container spacing={3} sx={{ justifyContent: "center" }}>
                            {[
                                {
                                    title: "Falta de planejamento tributário",
                                    description: "Você não sabe se está no Anexo III ou V do Simples Nacional, e a diferença pode ser de 13 pontos percentuais.",
                                },
                                {
                                    title: "Confusão com Split de Pagamento",
                                    description: "O Split de Pagamento com coprodutor gerou confusão fiscal que ninguém soube resolver.",
                                },
                                {
                                    title: "Dados reportados para a Receita",
                                    description: "A Hotmart e a Eduzz enviam dados para a Receita, e você não sabe o que exatamente foi reportado.",
                                },
                                {
                                    title: "Imposto surpresa",
                                    description: "Você lançou, faturou bem, e só depois descobriu o imposto que vinha na próxima guia.",
                                },
                                {
                                    title: "Risco de malha fina",
                                    description: "Você tem afiliados, coprodutores e sócios, e a estrutura jurídica virou um nó.",
                                },
                            ].map((item, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <Card
                                        sx={{
                                            height: "100%",
                                            width: window.innerWidth < 600 ? "100%" : "300px",
                                            borderRadius: "28px",
                                            background:
                                                "rgba(255,255,255,0.8)",
                                            backdropFilter: "blur(20px)",
                                            border:
                                                "1px solid rgba(0,0,0,0.05)",
                                            boxShadow:
                                                "0 20px 60px rgba(0,0,0,0.06)",
                                            transition: ".35s",
                                            position: "relative",
                                            overflow: "hidden",

                                            "&:hover": {
                                                transform:
                                                    "translateY(-8px)",
                                                boxShadow:
                                                    "0 30px 80px rgba(156,1,185,0.12)",
                                            },

                                            "&:before": {
                                                content: '""',
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: 4,
                                                background:
                                                    "linear-gradient(90deg,#9C01B9,#1EFF86)",
                                            },
                                        }}
                                    >
                                        <CardContent
                                            sx={{
                                                p: 4,
                                            }}
                                        >
                                            {/* Número */}
                                            <Typography
                                                sx={{
                                                    fontSize: "4rem",
                                                    fontWeight: 900,
                                                    color:
                                                        "rgba(156,1,185,0.08)",
                                                    lineHeight: 1,
                                                    mb: 2,
                                                }}
                                            >
                                                0{index + 1}
                                            </Typography>

                                            {/* Ícone */}
                                            <Box
                                                sx={{
                                                    width: 64,
                                                    height: 64,
                                                    borderRadius: "18px",
                                                    background:
                                                        "rgba(156,1,185,0.08)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mb: 3,
                                                }}
                                            >
                                                <WarningAmberIcon
                                                    sx={{
                                                        color: "#9C01B9",
                                                        fontSize: 32,
                                                    }}
                                                />
                                            </Box>

                                            <Typography
                                                sx={{
                                                    fontWeight: 800,
                                                    fontSize: "1.3rem",
                                                    mb: 2,
                                                }}
                                            >
                                                {item.title}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#666",
                                                    lineHeight: 1.8,
                                                }}
                                            >
                                                {item.description}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Box>

                {/* BENEFÍCIOS */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        background: "#050505",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    {/* Glow Roxo */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 500,
                            height: 500,
                            borderRadius: "50%",
                            background: "#9C01B9",
                            opacity: 0.15,
                            filter: "blur(180px)",
                            top: -250,
                            left: -250,
                        }}
                    />

                    {/* Glow Verde */}
                    <Box
                        sx={{
                            position: "absolute",
                            width: 450,
                            height: 450,
                            borderRadius: "50%",
                            background: "#1EFF86",
                            opacity: 0.08,
                            filter: "blur(180px)",
                            bottom: -250,
                            right: -250,
                        }}
                    />

                    <Container maxWidth="lg">
                        {/* Cabeçalho */}
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 8 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(255,255,255,0.05)",
                                    border: "1px solid rgba(255,255,255,0.08)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#1EFF86",
                                        fontSize: 13,
                                        fontWeight: 700,
                                        letterSpacing: 1,
                                    }}
                                >
                                    A SOLUÇÃO
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    color: "#FFF",
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    maxWidth: 900,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Como a{" "}
                                <Box
                                    component="span"
                                    sx={{
                                        background: "#1EFF86",
                                        WebkitBackgroundClip: "text",
                                        WebkitTextFillColor: "transparent",
                                    }}
                                >
                                    Contblack
                                </Box>{" "}
                                ajuda você a crescer com segurança
                            </Typography>

                            <Typography
                                sx={{
                                    color: "rgba(255,255,255,0.7)",
                                    maxWidth: 750,
                                    lineHeight: 1.8,
                                    fontSize: {
                                        xs: "1rem",
                                        md: "1.15rem",
                                    },
                                }}
                            >
                                A ContBlack entende o modelo de negócio de infoprodutos, de lançamentos a receita recorrente, de produtor solo a operações com coprodutores e afiliados. Configuramos seu Fator R, estruturamos o Split de Pagamento corretamente nas plataformas e garantimos conformidade com a Receita Federal a cada lançamento.
                            </Typography>
                        </Stack>

                        {/* Benefícios */}
                        <Grid container spacing={4} sx={{ justifyContent: "center" }}>
                            {[
                                {
                                    title: "CNPJ com Fator R Planejado",
                                    description: "Planejamento do Fator R para você ficar no Anexo III do Simples (6%) em vez do Anexo V (até 19,5%).",
                                    result: "Economia que faz diferença no seu bolso",
                                },
                                {
                                    title: "Split de Pagamento Configurado",
                                    description: "Configuração correta do Split de Pagamento entre produtor e coprodutor, sem bitributação.",
                                    result: "Tranquilidade para estruturar parcerias e crescer",
                                },
                                {
                                    title: "Dados Corretos Reportados para a Receita",
                                    description: "CNPJ com os CNAEs certos para produtor, coprodutor e afiliado.",
                                    result: "Conformidade fiscal e segurança para seu negócio",
                                },
                                {
                                    title: "Conformidade com e-Financeira",
                                    description: "Conformidade com a e-Financeira da Hotmart, Kiwify e Eduzz, sem risco de malha fina.",
                                    result: "Segurança fiscal e foco no crescimento, sem surpresas",
                                },
                                {
                                    title: "Suporte para Lançamentos Sazonais",
                                    description: "Suporte para lançamentos sazonais com variação grande de faturamento.",
                                    result: "Planejamento para picos de receita e controle do imposto a pagar",
                                },
                                {
                                    title: "Declaração de IRPF Alinhada com Receita da Empresa",
                                    description: "Declaração de IRPF do sócio alinhada com a receita da empresa.",
                                    result: "Evita malha fina e mantém sua vida financeira em ordem",
                                },
                            ].map((item, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <Card
                                        sx={{
                                            height: "100%",
                                            width: window.innerWidth < 600 ? "100%" : "300px",
                                            background:
                                                "rgba(255,255,255,0.04)",
                                            backdropFilter: "blur(20px)",
                                            border:
                                                "1px solid rgba(255,255,255,0.08)",
                                            borderRadius: "28px",
                                            position: "relative",
                                            overflow: "hidden",
                                            transition: ".35s",

                                            "&:hover": {
                                                transform:
                                                    "translateY(-8px)",
                                                border:
                                                    "1px solid rgba(30,255,134,0.25)",
                                                boxShadow:
                                                    "0 30px 80px rgba(30,255,134,0.08)",
                                            },

                                            "&::before": {
                                                content: '""',
                                                position: "absolute",
                                                left: 0,
                                                top: 0,
                                                width: 4,
                                                height: "100%",
                                                background:
                                                    "linear-gradient(180deg,#9C01B9,#1EFF86)",
                                            },
                                        }}
                                    >
                                        <CardContent sx={{ p: 4 }}>
                                            <Box
                                                sx={{
                                                    width: 70,
                                                    height: 70,
                                                    borderRadius: "20px",
                                                    background:
                                                        "rgba(30,255,134,0.08)",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    mb: 3,
                                                }}
                                            >
                                                <CheckCircleIcon
                                                    sx={{
                                                        fontSize: 38,
                                                        color: "#1EFF86",
                                                    }}
                                                />
                                            </Box>

                                            <Typography
                                                sx={{
                                                    color: "#FFF",
                                                    fontWeight: 800,
                                                    fontSize: "1.35rem",
                                                    mb: 2,
                                                }}
                                            >
                                                {item.title}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color:
                                                        "rgba(255,255,255,0.7)",
                                                    lineHeight: 1.8,
                                                    mb: 3,
                                                }}
                                            >
                                                {item.description}
                                            </Typography>

                                            <Box
                                                sx={{
                                                    borderTop:
                                                        "1px solid rgba(255,255,255,0.08)",
                                                    pt: 2,
                                                }}
                                            >
                                                <Typography
                                                    sx={{
                                                        color: "#1EFF86",
                                                        fontWeight: 700,
                                                        fontSize: ".95rem",
                                                    }}
                                                >
                                                    ✓ {item.result}
                                                </Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Box>

                {/* FAQ */}
                <Box
                    sx={{
                        py: { xs: 10, md: 14 },
                        background: "#FFFFFF",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    <Container maxWidth="md">
                        <Stack
                            spacing={3}
                            alignItems="center"
                            textAlign="center"
                            sx={{ mb: 7 }}
                        >
                            <Box
                                sx={{
                                    px: 2,
                                    py: 1,
                                    borderRadius: "999px",
                                    background: "rgba(156,1,185,0.08)",
                                    border: "1px solid rgba(156,1,185,0.15)",
                                }}
                            >
                                <Typography
                                    sx={{
                                        color: "#9C01B9",
                                        fontSize: 13,
                                        fontWeight: 700,
                                        letterSpacing: 1,
                                    }}
                                >
                                    DÚVIDAS FREQUENTES
                                </Typography>
                            </Box>

                            <Typography
                                sx={{
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    fontSize: {
                                        xs: "2rem",
                                        md: "3.5rem",
                                    },
                                }}
                            >
                                Perguntas que recebemos com frequência
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#666",
                                    maxWidth: 700,
                                    lineHeight: 1.8,
                                }}
                            >
                                Separamos as principais dúvidas sobre contabilidade,
                                tributação e regularização para infoprodutores.
                            </Typography>
                        </Stack>

                        {[
                            {
                                question: "O que é o Fator R e por que ele é importante?",
                                answer: "O Fator R determina em qual Anexo do Simples Nacional você é tributado. Com Fator R ≥ 28%, você vai para o Anexo III (6%). Sem planejamento, cai no Anexo V (até 19,5%).",
                            },
                            {
                                question: "A Hotmart reporta meu faturamento para a Receita?",
                                answer: "Sim, via e-Financeira. Todos os pagamentos acima de R$5.000 são notificados. Estar em conformidade é obrigatório.",
                            },
                            {
                                question: "A ContBlack atende coprodutores e afiliados também?",
                                answer: "Sim, com CNAEs e estrutura tributária específicos para cada modelo.",
                            }
                        ].map((item, index) => (
                            <Accordion
                                key={index}
                                disableGutters
                                elevation={0}
                                sx={{
                                    mb: 2,
                                    borderRadius: "20px !important",
                                    overflow: "hidden",
                                    border: "1px solid rgba(0,0,0,0.08)",
                                    boxShadow:
                                        "0 10px 30px rgba(0,0,0,0.04)",

                                    "&:before": {
                                        display: "none",
                                    },
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            sx={{
                                                color: "#9C01B9",
                                            }}
                                        />
                                    }
                                    sx={{
                                        minHeight: 80,
                                        px: 3,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontWeight: 700,
                                            fontSize: {
                                                xs: "1rem",
                                                md: "1.1rem",
                                            },
                                        }}
                                    >
                                        {item.question}
                                    </Typography>
                                </AccordionSummary>

                                <AccordionDetails
                                    sx={{
                                        px: 3,
                                        pb: 3,
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color: "#666",
                                            lineHeight: 1.8,
                                        }}
                                    >
                                        {item.answer}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}

                        {/* CTA Final */}
                        <Box
                            sx={{
                                mt: 6,
                                p: 4,
                                borderRadius: "24px",
                                background:
                                    "linear-gradient(135deg, rgba(156,1,185,0.05), rgba(30,255,134,0.05))",
                                border: "1px solid rgba(156,1,185,0.08)",
                                textAlign: "center",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontWeight: 800,
                                    fontSize: {
                                        xs: "1.2rem",
                                        md: "1.5rem",
                                    },
                                    mb: 1,
                                }}
                            >
                                Ainda ficou com alguma dúvida?
                            </Typography>

                            <Typography
                                sx={{
                                    color: "#666",
                                    mb: 3,
                                }}
                            >
                                Converse com um especialista e receba uma orientação
                                personalizada para sua situação.
                            </Typography>

                            <Button
                                sx={{
                                    background: "#9C01B9",
                                    color: "#FFF",
                                    px: 4,
                                    py: 1.5,
                                    borderRadius: "14px",
                                    fontWeight: 700,

                                    "&:hover": {
                                        background: "#83009A",
                                    },
                                }}
                                onClick={() => window.open(gerarLinkWhatsApp("Olá, gostaria de falar com um especialista sobre Infoprodutor."), '_blank')}
                            >
                                Falar com Especialista
                            </Button>
                        </Box>
                    </Container>
                </Box>

                <div ref={secaoRef}>
                    <FormularioNichos nicho="Infoprodutor" />
                </div>

                {/* FOOTER */}
                <Footer />
            </Box>
        </>
    );
}